import styled from "styled-components";
import { ConsultPostInfo } from "../../api/consultAPI";

interface Props {
  info: ConsultPostInfo;
}

// 성별/나이/장기 = 2열 그리드, 임상정보 = 전체폭(멀티라인)
const ConsultInfoPanel = ({ info }: Props) => {
  return (
    <Card>
      <CardTitle>Patient Information</CardTitle>
      <Grid>
        <Field>
          <Label>성별</Label>
          <Value>{info.gender || "-"}</Value>
        </Field>
        <Field>
          <Label>나이</Label>
          <Value>{info.age || "-"}</Value>
        </Field>
        <Field>
          <Label>장기</Label>
          <Value>{info.organ || "-"}</Value>
        </Field>
      </Grid>
      <ClinicalField>
        <Label>임상정보</Label>
        <ClinicalValue>{info.clinicalInfo || "-"}</ClinicalValue>
      </ClinicalField>
    </Card>
  );
};

export default ConsultInfoPanel;

const Card = styled.div`
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 10px;
  padding: 16px;
`;

const CardTitle = styled.div`
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: #8c8c8c;
  margin-bottom: 12px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
`;

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

const Label = styled.span`
  font-size: 0.72rem;
  font-weight: 600;
  color: #9b9a97;
`;

const Value = styled.span`
  font-size: 0.92rem;
  color: #262626;
  word-break: break-word;
`;

const ClinicalField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid #f0f0f0;
`;

const ClinicalValue = styled.div`
  font-size: 0.92rem;
  color: #262626;
  line-height: 1.55;
  white-space: pre-wrap;
  word-break: break-word;
`;
